import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  DialogContentText
} from "@material-ui/core";

import cc from "../../assets/cc.png";
import { closeInfoModal } from "../../actions/modalActions";

import "../../styles/processModal.scss";

class InfoModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleClose = () => {
    if (new Date() - this.props.modalOpenTime > 1000) {
      this.props.closeInfoModal();
    }
  };

  render() {
    const actions = [
      <Button color="secondary" onClick={this.handleClose}>
        Close
      </Button>
    ];

    const abbreviations = [
      {
        name: (
          <>
            <sup>t</sup>Am
          </>
        ),
        description: "tert-Amyl"
      },
      { name: "acac", description: "Acetylacetonate" },
      { name: "AMD", description: "Acetamidinate" },
      { name: "Bu", description: "Butyl" },
      {
        name: (
          <>
            <sup>t</sup>Bu
          </>
        ),
        description: "tert-Butyl"
      },
      {
        name: (
          <>
            <sup>i</sup>Bu
          </>
        ),
        description: "Isobutyl"
      },
      {
        name: (
          <>
            <sup>n</sup>Bu
          </>
        ),
        description: "n-Butyl"
      },
      {
        name: (
          <>
            <sup>s</sup>Bu
          </>
        ),
        description: "sec-Butyl"
      },
      { name: "CCTBA ", description: "μ2-η2-(tert-Butylacetylene)-dicobalthexacarbonyl" },
      { name: "CHD ", description: "2‑Methyl-1,4-bis(trimethylsilyl)-2,5-cyclohexadiene" },
      { name: "CHT", description: "Cycloheptatrienyl" },
      { name: "cod", description: "1,5-Cyclooctadiene" },
      { name: "Cp", description: "Cyclopentadienyl" },
      { name: "DAD", description: "Diazabutadiene" },
      { name: "demamp ", description: "1-{[2-(Dimethylamino)ethyl](methyl)amino}-2-methyl-2-propoxide"},
      { name: "DHP ", description: "1,4-Bis(trimethylsilyl)-1,4-dihydropyrazine" },
      { name: "dmae ", description: "Dimethylaminoethoxide"},
      { name: "dmamb", description: "1-Dimethylamino-2-methyl-2-butoxide" },
      { name: "dmamp ", description: "1-Dimethylamino-2-methyl-2-propoxide" },
      { name: "dmap ", description: "1-Dimethylamino-2-propoxide" },
      { name: "DMBD", description: "η4-2,3-dimethyl-1,3-butadiene"},
      { name: "dmb", description:"3,3-dimethyl-1-butene"},
      { name: "dmg", description: "Dimethylglyoximate"},
      { name: "DPDMG", description:"N,N’-diisopropyl-2-dimethylamidoguanidinate"},
      { name: "EB", description: "ethylbenzene"},
      { name: "eeki",description:"N-(2’-ethoxyethyl)-2-penten-2-on-4-iminate"},
      { name: "EBCHD", description: "(Ethylbenzene)(1,3-cyclohexadiene)"},
      { name: "EBECH", description: "(Ethylbenzyl)(1-ethyl-1,4-cyclohexadienyl)"},
      { name: "edpa ", description: "N-Ethoxy-2,2-dimethylcarboxylicpropanamide"},
      { name: "Et", description: "Ethyl" },
      { name: "FMD", description: "Formamidinate" },
      { name: "fod ", description: "6,6,7,7,8,8,8-Heptafluoro-2,2-dimethyl-3,5-octanedionate"},
      { name: "hfac", description: "Hexafluoroacetylacetonato" },
      { name: "hmds ", description: "Hexamethyldisilazanide"},
      { name: "IMBCH", description: "η6-1-Isopropyl-4-methylbenzene-η4-cyclohexa-1,3-diene"},
      { name: "Me", description: "Methyl" },
      { name: "mhdk", description:"5-methyl-2,4-hexanediketonate"},
      { name: "mmp ", description: "1-Methoxy-2-methyl-2-propoxide"},
      { name: "NHC ", description: "N-Heterocyclic carbene" },
      { name: "od", description: "octane-2,4-dionate"},
      {
        name: (
          <>
            <sup>n</sup>Pr
          </>
        ),
        description: "n-propoxide"
      },
      {
        name: (
          <>
            <sup>i</sup>Pr
          </>
        ),
        description: "Isopropyl"
      },
      { name: "pz ", description: "Pyrazolate" },
      { name: "thd", description: "2,2,6,6-Tetramethyl-3,5-heptanedionato" },
      { name: "TMEDA ", description: "N,N,N′,N′-Tetramethylethylenediamine" },
      { name: "TMPDA ", description: "N,N,N′,N′‐Tetramethyl‐1,3‐propanediamine" },
      { name: "Tp", description: "Tris(pyrazolyl)borate" },

    ];

    return (
      <Dialog
        open={this.props.isOpen}
        onClose={this.handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>About this periodic table</DialogTitle>
        <DialogContent>
          <DialogContentText>
            This periodic table is basically a database that gives an overview
            of the materials prepared by atomic layer deposition (ALD). It lists
            materials deposited from processes consisting of up to four
            reactants. Materials prepared by MLD are not included. See also the
            “Credits” button in the menu.
            <br /> <br />
            <a rel="license" href="http://creativecommons.org/licenses/by/4.0/">
              <img
                alt="Creative Commons License"
                style={{ borderWidth: 0 }}
                src={cc}
              />
            </a>
            <br />
            This work is licensed under a{" "}
            <a rel="license" href="http://creativecommons.org/licenses/by/4.0/">
              Creative Commons Attribution 4.0 International License
            </a>
            .<br />
            If you want to refer to this database, you can use the DOI:{" "}
            <a href="https://doi.org/10.6100/alddatabase">
              10.6100/alddatabase
            </a>
            <br /> <br />
            In case a material or process is missing or has been newly
            developed, you can add it using the “Add process” button in the
            menu. Additions will first be screened before appearing in the
            database.
            <br /> <br />
            You can submit comments through the “Submit comment” button on the
            menu. With “Save image” you can make a png-image of the periodic
            table.
            <br /> <br />
            The periodic table shows pure elements as well as compounds with
            oxygen, nitrogen, sulphur, selenium, tellurium, fluorine, and other
            compounds grouped together as indicated through shadings of
            different types at different positions. The elements are named
            according to the recommendations of The International Union of Pure
            and Applied Chemistry.
            <br /> <br />
            The following abbreviations are used for ligands:
            <br /> <br />
            {abbreviations.map(abbreviation => (
              <>
                <b>{abbreviation.name}</b>: {abbreviation.description}
                <br />
              </>
            ))}
          </DialogContentText>
        </DialogContent>
        <DialogActions>{actions}</DialogActions>
      </Dialog>
    );
  }
}

function mapStateToProps(state) {
  return {
    isOpen: state.modal.infoModalIsOpen,
    modalOpenTime: state.modal.modalOpenTime
  };
}

export default connect(
  mapStateToProps,
  { closeInfoModal }
)(InfoModal);
